<ng-container *ngIf="template$ | async as template">
  <div
    class="
      jumbotron
      rounded
      mb-0
      mt-sm-4
      bg-300
      container-fluid
      p-0
      ratio ratio-16x9
    "
    title="jumbotron"
    data-test="jumbotron"
    *ngIf="template.heroImage as hero"
  >
    <img
      floResponsiveImg
      [src]="hero?.url"
      [alt]="hero?.alt"
      [sources]="hero?.sources"
      [sizes]="hero?.sizes"
      class="img-fluid rounded"
    />
  </div>
  <nav
    aria-label="breadcrumb"
    data-test="event-header-nav"
    class="
      d-flex
      mt-md-3
      pt-md-3 pt-3
      mt-2
      justify-content-between
      w-100
      flex-wrap
    "
    [ngClass]="template.navStyle"
  >

    <div [ngClass]="template.drillThroughStyle">

          <div>
            <a
              *ngIf="template.drill_through_link as drillThrough"
              data-test="breadcrumb-item"
              class="drill-through"
              floAnalytics
              [analyticsProperties]="drillThroughAnalytics$ | async"
              [routerLink]="drillThrough?.slug_uri"
            >
              {{ drillThrough?.name }}</a
            >
          </div>


      <div class="px-0 d-none d-md-block">
        <flo-collection-cta
          data-test="collection-primary-cta"
          [cta]="cta$ | async"
          [coreNodeId]="template.coreNodeId"
          [collectionType]="template.collectionType"
          [isUserLoggedIn]="template.isUserLoggedIn"
        ></flo-collection-cta>
      </div>
    </div>
    <h1
      class="display-4 d-block text-700 mb-0 mt-0 pt-1 text-break"
      [ngClass]="template.titleStyle"
      *ngIf="template.headerText"
      data-test="header-text"
    >
      {{ template.headerText }}
    </h1>
    <h2
      class="col-12 mb-0 mt-0 pt-0 text-break"
      [ngClass]="template.titleStyle"
      *ngIf="template.subheaderText"
      data-test="subheader-text"
    >
      {{ template.subheaderText }}
    </h2>
  </nav>
  <time class="headline d-block text-700" *ngIf="template.date">{{
    template.date
  }}</time>
  <section
    data-test="collection-header-description"
    class="mt-2 pt-1 mb-sm-0 mb-1 font-family-regular text-700"
    *ngIf="template.description"
  >
    <div class="row">
      <div class="col-md-12" floDynamicContent>
        <ng-container
          *ngIf="{
            showPreviewText: showPreviewText$ | async,
            readMoreBtnText: readMoreBtnText$ | async
          } as previewProps"
        >
          <p
            *ngIf="previewProps.showPreviewText && template.preview_text"
            class="text-700"
            data-test="preview-text"
            [innerHtml]="template.preview_text | floSanitizeHtml"
          ></p>
          <p
            *ngIf="!previewProps.showPreviewText"
            class="text-700"
            data-test="description"
            [innerHtml]="template.description | floSanitizeHtml"
          ></p>
          <div class="mb-2">
            <a
              *ngIf="!!previewProps.readMoreBtnText"
              class="primary-color-text subhead see-more-btn"
              data-test="see-more-btn"
              (click)="handleSeeMoreClick(showMore$.getValue())"
            >
              {{ previewProps.readMoreBtnText }}
            </a>
          </div>
        </ng-container>
      </div>
    </div>
  </section>
  <h6 class="subhead text-muted" *ngFor="let supporter of template.supporters">
    Presented by <a [routerLink]="supporter.url">{{ supporter.name }}</a>
  </h6>
  <!-- <div class="text-center d-block d-md-none mb-3">
    <flo-ad-rectangle
      class="ad-fadeIn"
      [limitTallUnits]="true"
      [displayOnMobile]="true"
      [displayOnTablet]="false"
      [displayOnDesktop]="false"
    >
    </flo-ad-rectangle>
  </div> -->
</ng-container>
